export const T = {
  en_GB: {
    noAccountsYet: "No accounts yet. Accounts appear here once synced from the bank.",
    pendingAccount: "awaiting bank",
    position: "position",
    positions: "positions",
    error: "Error",
    ok: "OK",
    isin: "ISIN",
    name: "Name",
    type: "Type",
    holding: "Holding",
    cash: "Cash",
    noPositions: "No positions in this account.",
    externalId: "External ID",
    vendor: "Vendor",
    currency: "Currency",
    cashAmount: "Cash Amount",
    wrapperType: "Wrapper Type",
    linkedGoal: "Linked Goal",
    notSet: "—",
    followup: "Followup",
    estimated: "estimated",
  },
  nb_NO: {
    noAccountsYet: "Ingen kontoer ennå. Kontoer vises her når de er synkronisert fra banken.",
    pendingAccount: "venter på bank",
    position: "posisjon",
    positions: "posisjoner",
    error: "Feil",
    ok: "OK",
    isin: "ISIN",
    name: "Navn",
    type: "Type",
    holding: "Beholdning",
    cash: "Kontanter",
    noPositions: "Ingen posisjoner i denne kontoen.",
    externalId: "Ekstern ID",
    vendor: "Leverandør",
    currency: "Valuta",
    cashAmount: "Kontantbeløp",
    wrapperType: "Innpakningstype",
    linkedGoal: "Tilknyttet mål",
    notSet: "—",
    followup: "Oppfølging",
    estimated: "estimert",
  },
} as const;
